import type { ReactNode } from "react";
import { styled } from "@pigment-css/react";

export const BOTTOM_NAV_TAB_ROW_HEIGHT = "72";

const Row = styled("div")(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  gap: theme.fieldSalesTwo.spacing[8],
  width: "100%",
  minHeight: theme.fieldSalesTwo.spacing[BOTTOM_NAV_TAB_ROW_HEIGHT],
}));

interface BottomNavTabRowProps {
  children: ReactNode;
}

export function BottomNavTabRow({ children }: BottomNavTabRowProps) {
  return <Row>{children}</Row>;
}
